import globalErrorHandler from '../../Error/globalErrorHandler.fun';
import {
  Obj
} from '../../Object.lib';
import {
  COLLECTION__EMPLOYERS,
  readLoopbackRecord
} from '../BE/loopback.api';
import getAtsContextMapped from './getAtsContextMapped.fun';

const CACHE = {};

/**
 * Fetches the ATS context for a given entity.
 *
 * @async
 * @param {object} options - The options object.
 * @param {string} [options.collection=COLLECTION__EMPLOYERS] - The collection name to fetch the entity from.
 * @param {string} options.entityId - The ID of the entity to fetch.
 * @param {string} [options.atsTypeId] - The provider ID to use for fetching the ATS context. Defaults to the entity's atsTypeId.
 * @returns {Promise<object>} The entity object with the mapped ATS context.
 * @throws Will call globalErrorHandler on error.
 */
export default async function fetchAtsContext({
  collection = COLLECTION__EMPLOYERS,
  entityId = '',
  atsTypeId = ''
}) {
  try {
    const NOW = Date.now();
    if (
      CACHE[entityId] &&
      (CACHE[entityId].lastUpdated + 60000) > NOW
    ) {
      return CACHE[entityId].entity;
    }
    const entity = Obj(
      await readLoopbackRecord({
        collection,
        fields: ['id', 'atsTypeId', 'atsUrl', 'atsJobId', 'atsApiProviders', 'atsContext'],
        where: { id: entityId },
        limit: 1
      })
    );
    entity.atsContext = getAtsContextMapped({
      collection,
      entity,
      atsTypeId: atsTypeId || entity.atsTypeId
    });
    CACHE[entityId] = {
      entity,
      lastUpdated: NOW
    };
    return entity;
  }
  catch (error) {
    globalErrorHandler(error);
  }
}
